import type { Tour } from '../../types';

export const dashboardTour: Tour = {
  id: 'institution-dashboard',
  name: 'Dashboard Tour',
  description: 'Learn how to use the dashboard to monitor your institution',
  category: 'institution',
  showProgress: true,
  requiredPath: '/dashboard',
  steps: [
    {
      id: 'dashboard-1',
      target: 'dashboard-header',
      title: 'Dashboard Overview',
      content: 'Your dashboard provides a comprehensive view of your institution\'s document management activity. Let\'s explore the key sections.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'dashboard-2',
      target: 'dashboard-stats',
      title: 'Quick Statistics',
      content: 'These cards show key metrics at a glance: total documents, pending approvals, active tasks, and recent uploads.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'dashboard-3',
      target: 'dashboard-recent-docs',
      title: 'Recent Documents',
      content: 'View the most recently added or modified documents. Click any document to view its details.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'dashboard-4',
      target: 'dashboard-pending-tasks',
      title: 'Pending Tasks',
      content: 'Documents waiting for your review or approval appear here. Take action directly from the dashboard.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'dashboard-5',
      target: 'dashboard-activity',
      title: 'Activity Feed',
      content: 'Track all document activities in your institution: uploads, approvals, comments, and status changes.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'dashboard-6',
      target: 'dashboard-quick-actions',
      title: 'Quick Actions',
      content: 'Common actions like uploading documents, creating folders, or starting workflows are available here for quick access.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'dashboard-7',
      target: 'dashboard-chart',
      title: 'Document Analytics',
      content: 'Visual charts help you understand document trends, classification distribution, and activity patterns.',
      position: 'top',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
